import Constants from 'expo-constants';

import type { HomeSurveyConfigPayload } from '@/types';

const environment = Constants.expoConfig?.extra?.appVariant || 'development';
const isProduction = environment === 'production';

const LEVEL_TO_WP_SLUG_PROD: Record<string, string> = {
  'level-1': 'beginner',
  'level-2': 'intermediate',
  'level-3': 'advanced',
  'level-4': 'advanced',
};

const LEVEL_TO_WP_SLUG_STAGING: Record<string, string> = {
  'level-1': 'level-1',
  'level-2': 'level-2',
  'level-3': 'level-3',
  'level-4': 'level-4',
};

export const HOME_SURVEY_LEVEL_TO_WP_SLUG: Record<string, string> = isProduction
  ? LEVEL_TO_WP_SLUG_PROD
  : LEVEL_TO_WP_SLUG_STAGING;

export const HOME_SURVEY_INSTRUMENT_TO_WP_SLUG: Record<string, string> = {
  piano: 'piano',
  bass: 'bass',
  guitar: 'guitar',
  drums: 'drums',
  trumpet: 'trumpet',
  vocals: 'vocals',
  saxophone: 'saxophone',
  vibraphone: 'vibraphone',
};

export interface ResolvedHomeSurvey {
  level: string;
  instrument: string;
}

function slugKey(value: string | number): string {
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-');
}

export function resolveHomeSurvey(cfg: HomeSurveyConfigPayload): ResolvedHomeSurvey | null {
  const levelKey = typeof cfg.level === 'number' ? `level-${cfg.level}` : slugKey(cfg.level);
  const instKey = slugKey(cfg.instrument);

  const level = HOME_SURVEY_LEVEL_TO_WP_SLUG[levelKey];
  const instrument = HOME_SURVEY_INSTRUMENT_TO_WP_SLUG[instKey];
  if (!level || !instrument) return null;
  return { level, instrument };
}
